import React from 'react';
import ReactDOM from 'react-dom';
import { RecommercePreview } from '@finn-no/recommerce-extended-profilebox';
import Fallback from './Fallback.js';
import RealestateApp from './RealestateApp.js';
import { RealEstateOrRecommerce } from '../common/types.js';
import RecommerceApp from './RecommerceApp.js';

class WebComponent extends HTMLElement {
    constructor() {
        super();
        const dataNode = this.querySelector(
            '[data-company-profile-data]',
        ) as HTMLElement;
        const initialState =
            dataNode &&
            dataNode.textContent &&
            (JSON.parse(dataNode.textContent) as RealEstateOrRecommerce);
        if (initialState) {
            const shadow = this.attachShadow({ mode: 'open' });
            shadow.innerHTML = this.innerHTML;
            const innerNode = shadow.querySelector(
                '[data-company-profile]',
            ) as HTMLElement;
            this.innerHTML = '';

            if (initialState.type === 'fallback') {
                ReactDOM.hydrate(<Fallback />, innerNode);
            } else if (initialState.type === 'recommerce-preview') {
                ReactDOM.hydrate(<RecommercePreview />, innerNode);
            } else if (initialState.type === 'recommerce') {
                ReactDOM.hydrate(
                    <RecommerceApp {...initialState} />,
                    innerNode,
                );
            } else {
                ReactDOM.hydrate(
                    <RealestateApp
                        {...{
                            ...initialState,
                            companyProfile: initialState.companyProfile,
                        }}
                    />,
                    innerNode,
                );
            }
        } else {
            // eslint-disable-next-line no-lonely-if
            if (process.env.NODE_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.log('missing data element', this, initialState);
            }
        }
    }
}

if (!customElements.get('company-profile-podlet')) {
    customElements.define('company-profile-podlet', WebComponent);
}
